import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { useSnapshotSpec } from '@flipster/features/src/shared/snapshot/use-snapshot-spec';
import { marketsBunja } from '@flipster/r230522/original/market';

import { useTimeTriggerTpslModal } from '@web/features/modals/TimeTriggerTpslModal/useTimeTriggerTpslModal';

export function useTimeTriggerTpslBaseInfo() {
  const { marketsAtom } = useBunja(marketsBunja);
  const markets = useAtomValue(marketsAtom);

  const { tpSlInfo } = useTimeTriggerTpslModal();
  const { instrumentsKeyBySymbol } = useSnapshotSpec();

  const symbol = tpSlInfo?.symbol || '';
  const socketSymbol = markets?.[symbol];
  const apiSymbol = instrumentsKeyBySymbol?.[symbol];

  return { symbol, socketSymbol, apiSymbol };
}
